"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _serverError = require("../actions/server-error");

var _default = function _default(_a) {
  var _b = _a === void 0 ? {} : _a,
      onGlobalWarning = _b.onGlobalWarning,
      onUnauthorized = _b.onUnauthorized;

  return function (_a) {
    var getState = _a.getState,
        dispatch = _a.dispatch;
    return function (next) {
      return function (action) {
        if (action.type === _serverError.THROW_SERVER_ERROR) {
          var _a = action.meta,
              status_1 = _a.status,
              ignoreGlobalWarning = _a.ignoreGlobalWarning,
              ignoreAuthRedirection = _a.ignoreAuthRedirection,
              payload = action.payload;

          if (!ignoreGlobalWarning && onGlobalWarning) {
            onGlobalWarning({
              payload: payload,
              getState: getState,
              dispatch: dispatch
            });
          }

          if ((status_1 === 401 || status_1 === 403) && !ignoreAuthRedirection && onUnauthorized) {
            onUnauthorized({
              payload: payload,
              getState: getState,
              dispatch: dispatch
            });
          }
        }

        return next(action);
      };
    };
  };
};

exports.default = _default;